<app-avatar
  [src]="src()"
  [alt]="avatarAlt()"
  [size]="size()"
  [shape]="shape()"
  [color]="avatarColor()"
  [label]="avatarLabel()"
/>
